import React, { useState, useEffect } from 'react';
import HistoryModal from '../../history/HistoryModal';
import { ContactSupportDialog } from '../../support';
import SettingsModal from '../../settings/SettingsModal';
import { SettingsKeys } from '../../settings/settingsSlice';

const BottomActionsModals: React.FC = () => {
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [supportDialogOpen, setSupportDialogOpen] = useState(false);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);
  const [settingsInitialTab, setSettingsInitialTab] =
    useState<SettingsKeys>('user');

  useEffect(() => {
    // Check for modal state changes from BottomActions
    const checkModalStates = () => {
      if (
        typeof window !== 'undefined' &&
        (window as any).__bottomActionsModals
      ) {
        const modals = (window as any).__bottomActionsModals;
        setHistoryModalOpen(modals.historyModalOpen);
        setSupportDialogOpen(modals.supportDialogOpen);
        setSettingsModalOpen(modals.settingsModalOpen);
        if (modals.settingsInitialTab) {
          setSettingsInitialTab(modals.settingsInitialTab);
        }
      }
    };

    // Check immediately
    checkModalStates();

    // Set up an interval to check for changes
    const interval = setInterval(checkModalStates, 100);

    return () => clearInterval(interval);
  }, []);

  // Update global state when modals close
  const handleHistoryClose = () => {
    setHistoryModalOpen(false);
    if ((window as any).__bottomActionsModals) {
      (window as any).__bottomActionsModals.historyModalOpen = false;
      (window as any).__bottomActionsModals.setHistoryModalOpen(false);
    }
  };

  const handleSupportClose = () => {
    setSupportDialogOpen(false);
    if ((window as any).__bottomActionsModals) {
      (window as any).__bottomActionsModals.supportDialogOpen = false;
      (window as any).__bottomActionsModals.setSupportDialogOpen(false);
    }
  };

  const handleSettingsClose = () => {
    setSettingsModalOpen(false);
    if ((window as any).__bottomActionsModals) {
      (window as any).__bottomActionsModals.settingsModalOpen = false;
      (window as any).__bottomActionsModals.setSettingsModalOpen(false);
    }
  };

  return (
    <>
      {/* Modals */}
      {supportDialogOpen && (
        <ContactSupportDialog onClose={handleSupportClose} />
      )}

      {historyModalOpen && (
        <HistoryModal open={historyModalOpen} onClose={handleHistoryClose} />
      )}

      {/* Settings Modal */}
      <SettingsModal
        open={settingsModalOpen}
        onClose={handleSettingsClose}
        initialTab={settingsInitialTab}
      />
    </>
  );
};

export default BottomActionsModals;
